import type { LocalizationMap } from './Localization/Localization';
// ------------------------------------------------------------------------------------------------
export const CalendarLocalizationTextMapKey: string = 'Primitive_Calendar';
// ------------------------------------------------------------------------------------------------
export const enum UILabelKey {
    date = 'date',
    time = 'time',
    event = 'event',
    allDay = 'allDay',
    week = 'week',
    work_week = 'work_week',
    day = 'day',
    month = 'month',
    previous = 'back',
    next = 'next',
    yesterday = 'yesterday',
    tomorrow = 'tomorrow',
    today = 'today',
    agenda = 'agenda',
    noEventsInRange = 'noEventsInRange',
    showMore = 'showMore',
    legend = 'legend'
}
// ------------------------------------------------------------------------------------------- 
export function GetCalendarLocalizationDictionary(): LocalizationMap {
    return {
        [UILabelKey.date]: 'Date',
        [UILabelKey.time]: 'Time',
        [UILabelKey.event]: 'Event',
        [UILabelKey.allDay]: 'All Day',
        [UILabelKey.week]: 'Week',
        [UILabelKey.work_week]: 'Work Week',
        [UILabelKey.day]: 'Day',
        [UILabelKey.month]: 'Month',
        [UILabelKey.previous]: 'Back',
        [UILabelKey.next]: 'Next',
        [UILabelKey.yesterday]: 'Yesterday',
        [UILabelKey.tomorrow]: 'Tomorrow',
        [UILabelKey.today]: 'Today',
        [UILabelKey.agenda]: 'Agenda',
        [UILabelKey.noEventsInRange]: 'There are no events in this range.',
        [UILabelKey.showMore]: 'more',
        [UILabelKey.legend]: 'Show legend info',
    };
}
// -------------------------------------------------------------------------------------------